import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { INTEGRATION_STATUS } from 'voxloud-types/dist/models/integrations';

@Component({
  selector: 'gdp-select-integration-status',
  templateUrl: './select-integration-status.component.html',
  styleUrls: ['./select-integration-status.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectIntegrationStatusComponent),
      multi: true
    }
  ]
})
export class SelectIntegrationStatusComponent {
  public INTEGRATION_STATUS: INTEGRATION_STATUS[] = Object.values(INTEGRATION_STATUS);
  public selectedIntegrationStatus: string = this.INTEGRATION_STATUS[0]

  onChange: any = () => { }
  onTouch: any = () => { }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(val: INTEGRATION_STATUS) {
    if (val) {
      this.selectedIntegrationStatus = val;
    }
  }

  public selectIntegrationStatus(value: INTEGRATION_STATUS) {
    this.selectedIntegrationStatus = value;
    this.onChange(value);
  }
}
